var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "nk-footer-copyright" }, [
    _vm._v(
      _vm._s(_vm.trans("general.version") + " " + _vm.getConfig("v")) +
        " " +
        _vm._s(_vm.getConfig("footer_credit"))
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }